import { ReactNode } from "react";
import { Setting, Symbols } from "./type";
import BigNumber from "bignumber.js";
import { GameCodes } from "../../type";

const VikingBlastUtils = {
  isBuyingFreeSpin(bombCount: number): boolean {
    return bombCount >= 4;
  },
  cleanSymbolId(symbol: number): { symbolId: number; featureId: number } {
    const mod = symbol % 100;
    if (mod > 90) {
      const realSymbolId = +Math.floor(symbol / 100).toFixed(0);
      // 9X suffix, it is no regular symbol, need special handle
      if (mod === 91) {
        return { symbolId: realSymbolId, featureId: 1 };
      } else {
        return { symbolId: realSymbolId, featureId: +(mod - 90).toFixed(0) };
      }
    }
    if (symbol > 10 && symbol < 100 && symbol != Symbols.Scatter) {
      return {
        symbolId: +Math.floor(symbol / 10).toFixed(0),
        featureId: +(symbol % 10).toFixed(0),
      };
    }
    return {
      symbolId: symbol,
      featureId: NaN,
    };
  },
  takeSymbol(reelMatrix: number[][], x: number, y: number): number {
    return reelMatrix[x][y];
  },
  convertSymbol(symbol: number, key?: string): ReactNode {
    if (Number.isNaN(symbol)) return "";
    switch (symbol) {
      case Symbols.RainbowGem:
        return <img key={key} alt="RainbowGem" src="/vb/201.png" />;
      case Symbols.Gold:
        return <img key={key} alt="Gold" src="/vb/202.png" />;
      case Symbols.Amber:
        return <img key={key} alt="Amber" src="/vb/203.png" />;
      case Symbols.Ruby:
        return <img key={key} alt="Ruby" src="/vb/204.png" />;
      case Symbols.Iolite:
        return <img key={key} alt="Iolite" src="/vb/101.png" />;
      case Symbols.VioletLollipop:
        return <img key={key} alt="VioletLollipop" src="/vb/102.png" />;
      case Symbols.Sapphire:
        return <img key={key} alt="Sapphire" src="/vb/103.png" />;
      case Symbols.Emerald:
        return <img key={key} alt="Emerald" src="/vb/104.png" />;
      case Symbols.Ship:
        return <img key={key} alt="Ship" src="/vb/4.png" />;
      case Symbols.Axe:
        return <img key={key} alt="Axe" src="/vb/3.png" />;
      case Symbols.Horn:
        return <img key={key} alt="Horn" src="/vb/2.png" />;
      case Symbols.VikingBlast:
        return <img key={key} alt="VikingBlast" src="/vb/8.png" />;
      case Symbols.Scatter:
        return <img key={key} alt="Scatter" src="/vb/25.png" />;
      case 0:
        return <></>;
      default:
        return symbol;
    }
  },
  maxBetFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount).multipliedBy(50); // buy free spin rate
  },
  maxPayoutFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount)
      .multipliedBy(0.05) // bet size
      .multipliedBy(36) // 6*6 symbol count
      .multipliedBy(18) // max scatter multiplier
      .multipliedBy(2) // viking blast multiplier
      .multipliedBy(15); // max symbol payout
  },
} as const;

export default VikingBlastUtils;
